<template>
  <div class="answer">
    <strong>{{ question }}</strong>
    <span>{{ correct }}</span>
  </div>
</template>

<style lang="sass" scoped>
  @import '~/assets/stylesheets/utils/module.sass'

  .answer
    align-items: center
    border: 1px solid $light-gray
    border-radius: $border-radius
    color: $gray
    display: flex
    flex-direction: column
    height: $space-xxl
    justify-content: center
    line-height: 20px
    margin: 0 $space-s $space-s 0
    width: $space-xxl

</style>

<script>
export default {
  props:["question", "correct"]
}
</script>
